export const ACCACCOUNTCLOSE_LOADING = "ACCACCOUNTCLOSE_LOADING";
export const ACCACCOUNTCLOSE_RESET = "ACCACCOUNTCLOSE_RESET";
export const GET_ACCACCOUNTCLOSE = "GET_ACCACCOUNTCLOSE";
export const GET_ACCACCOUNTCLOSE_SUCCESS = "GET_ACCACCOUNTCLOSE_SUCCESS";
export const GET_ACCACCOUNTCLOSE_FAIL = "GET_ACCACCOUNTCLOSE_FAIL";
export const DELETE_ACCACCOUNTCLOSE = "DELETE_ACCACCOUNTCLOSE"
export const DELETE_ACCACCOUNTCLOSE_SUCCESS = "DELETE_ACCACCOUNTCLOSE_SUCCESS"
export const DELETE_ACCACCOUNTCLOSE_FAIL = "DELETE_ACCACCOUNTCLOSE_FAIL"
export const UPDATE_ACCACCOUNTCLOSE = "UPDATE_ACCACCOUNTCLOSE"
export const UPDATE_ACCACCOUNTCLOSE_SUCCESS = "UPDATE_ACCACCOUNTCLOSE_SUCCESS"
export const UPDATE_ACCACCOUNTCLOSE_FAIL = "UPDATE_ACCACCOUNTCLOSE_FAIL"
export const ADD_NEW_ACCACCOUNTCLOSE = "ADD_NEW_ACCACCOUNTCLOSE"
export const ADD_ACCACCOUNTCLOSE_SUCCESS = "ADD_ACCACCOUNTCLOSE_SUCCESS"
export const ADD_ACCACCOUNTCLOSE_FAIL = "ADD_ACCACCOUNTCLOSE_FAIL"
export const ACCACCOUNTCLOSE_RESET_CREATE = "ACCACCOUNTCLOSE_RESET_CREATE"